<template>
  <v-card flat tile class="indigo lighten-1 white--text text-center">
    <v-card-text class="text-xs-center">
      <v-btn v-for="icon in icons" :key="icon" class="mx-4 white--text" icon>
        <v-icon medium>{{ icon }}</v-icon>
      </v-btn>
    </v-card-text>
    <v-card-text class="white--text pa-4 text-xs-center">{{foottext}}</v-card-text>
    <v-card-text class="white--text text-xs-center caption">{{affiltext}}</v-card-text>
    <v-divider></v-divider>
    <v-card-text class="white--text text-xs-center pa-3">
      <v-icon small color="white">copyright</v-icon>
      {{ new Date().getFullYear() }} —
      <strong>Munene J Art | All Rights Reserved | Email: jmunene6@gmail.com | Mobile/WhatsApp +254 725 804 404 | Facebook:  j.arthurmunene | Instagram:  munenej_art   </strong>
    </v-card-text>
  </v-card>
</template>
<script>
import Popup from "./Popup";
import Register from "./register";
import Login from "./login";
import router from "../router.js";
import Navbar from "./Navbar";
export default {
  components: {
    Popup,
    Register,
    Login,
    Navbar
  },
  data: () => ({
    foottext:
      "Some of the work displayed here is available for purchase. If you want custom art designed for you, Please get in touch using mobile, email or social media. |",
    icons: [
      "fab home",
      "fab language",
      "fab card_giftcard",
      "fab commute",
      "fab card_travel"
    ],
    affiltext:
      ""
  })
};
</script>